<div class="pdf-editor-tools">
  @for (toolGroup of toolGroups$ | async; track toolGroup) {
    <div
      class="pdf-editor-tools-group"
      >
      <div class="pdf-editor-tools-group-header">
        <h4 class="pdf-editor-tools-group-title">{{ toolGroup.title }}</h4>
        @if (toolGroup.allowCustomTool) {
          <div>
            <button
              type="button"
              title="Hinzufügen"
              (click)="addToolInGroup(toolGroup)"
              >
              <span class="fa-regular fa-plus"></span>
            </button>
          </div>
        }
      </div>
      <div class="pdf-editor-tools-group-content">
        @if (toolGroup.tools && toolGroup.tools.length) {
          <div
            class="pdf-editor-tool-container"
            >
            @for (tool of toolGroup.tools; track tool) {
              <button
                type="button"
                class="pdf-editor-tool"
                [ngClass]="{ active: (selectedTool$ | async) === tool }"
                (click)="selectTool(tool)"
                >
                @if (tool.type === 'IMAGE') {
                  <div class="pdf-editor-tool-image">
                    <img [class]="tool.icon" [src]="tool.url" [alt]="tool.type" />
                  </div>
                }
                @if (tool.type !== 'IMAGE') {
                  <div class="pdf-editor-tool-icon">
                    <span [class]="tool.icon"></span>
                  </div>
                }
                <div class="pdf-editor-tool-title">{{ tool.title }}</div>
              </button>
            }
          </div>
        } @else {
          <p class="text-sm text-center">Es sind keine Werkzeuge in dieser Kategorie vorhanden.</p>
        }
      </div>
      <div class="pdf-editor-tools-group-footer">
        @if ((selectedToolGroup$ | async)?.name === toolGroup.name) {
          @if ((selectedTool$ | async)?.isCustom) {
            <div
              class="pdf-editor-tool-controls"
              >
              <button
                type="button"
                class="pdf-editor-tool-control text-danger"
                (click)="deleteSelectedCustomTool()"
                >
                <span class="fa-regular fa-trash"></span>
                Delete
              </button>
            </div>
          }
          @if ((selectedTool$ | async)?.customizations) {
            <soft-pdf-editor-tool-customization
            ></soft-pdf-editor-tool-customization>
          }
        }
      </div>
    </div>
  }
</div>
